import "./styles.scss";

import Picture from "components/ui/picture";
import { cdnURL } from "components/utils/cdn";
import PropTypes from "prop-types";
import React from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "@mui/material";

const GiftCardsPromo = ({ className = "" }) => {
  const navigate = useNavigate();

  const onClick = () => {
    navigate("/cards/birthday-wishes?explainer=gift-cards");
  };

  return (
    <div className={`gift-cards-promo-container ${className}`}>
      <div className="gift-cards-promo-image-1">
        <Picture src={cdnURL("img/rebuild/promote/gift-cards/gift-cards-left.jpg")} has2x hasWebp alt="Gift Cards" width={406} height={300} />
      </div>
      <div className="gift-cards-promo-contents">
        <p className="gift-cards-promo-pretitle">NOW AVAILABLE!</p>
        <h2 className="gift-cards-promo-title">Add egift cards to all your Birthday Alarm cards</h2>
        <div className="gift-cards-promo-image-mobile">
          <div className="animation-container">
            <Picture src={cdnURL("img/rebuild/promote/gift-cards/gift-cards-strip.png")} has2x hasWebp alt="Gift Cards" width={1187} height={196} />
          </div>
        </div>
        <Button onClick={onClick}>GET STARTED</Button>
      </div>
      <div className="gift-cards-promo-image-2">
        <Picture src={cdnURL("img/rebuild/promote/gift-cards/gift-cards-right.jpg")} has2x hasWebp alt="Gift Cards" width={399} height={300} />
      </div>
    </div>
  );
};

GiftCardsPromo.propTypes = {
  className: PropTypes.string,
};

export default GiftCardsPromo;
